export { default as SEO } from "./seo";
